
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm7.405 7.294a.998.998 0 00-1.42.004l-7.676 7.676-3.522-3.522a1.007 1.007 0 00-1.418.008l-.07.07a1.001 1.001 0 00-.009 1.418l4.089 4.09a1 1 0 00.127.155l.051.052a.998.998 0 001.42-.005l8.475-8.475a1.003 1.003 0 00.005-1.42z"}})])
          )
        }
      }
    